import { render, staticRenderFns } from "./orderables-list-panel.vue?vue&type=template&id=07bd365a&scoped=true&lang=pug"
import script from "./orderables-list-panel.vue?vue&type=script&lang=js"
export * from "./orderables-list-panel.vue?vue&type=script&lang=js"
import style0 from "./orderables-list-panel.vue?vue&type=style&index=0&id=07bd365a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bd365a",
  null
  
)

export default component.exports